import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DeviceTypeDto } from 'src/app/api/asset/deviceTypeDto';
import { EditAssetCommand } from 'src/app/api/asset/editAssetCommand';
import { Asset } from 'src/app/api/asset/asset';
import { AssetApiService } from 'src/app/api/asset/assetApiService';
import moment from 'moment';

@Component({
    selector: 'edit-asset',
    templateUrl: './edit-asset.component.html',
    styleUrls: ['./edit-asset.component.css'],
    standalone: false
})
export class EditAssetComponent implements OnInit {
  loading: boolean = false;
  saving: boolean = false;
  error: string = '';
  editAssetCommand: EditAssetCommand = new EditAssetCommand();
  asset: Asset | null = null;
  deviceTypes: DeviceTypeDto[] = DeviceTypeDto.GetAvailableTypes();
  lifeCyclePhases: string[] = ['Classic', 'Active', 'Restricted', 'Limited', 'Legacy', 'Obsolete', 'Development', 'Unknown'];

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private router: Router,
    private assetApiService: AssetApiService
  ) { }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id == null)
      return;

    this.loading = true;
    this.assetApiService.getAsset(id)
      .subscribe(x => {
        this.asset = x[0];
        this.editAssetCommand = EditAssetCommand.fromAsset(this.asset);
        this.loading = false;
      });
  }

  update(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id == null)
      return;

    this.error = "";

    if (this.editAssetCommand.customerWarrantyStart != null
      && this.editAssetCommand.customerWarrantyEnd != null
      && moment(this.editAssetCommand.customerWarrantyStart) > moment(this.editAssetCommand.customerWarrantyEnd)) {
      this.error = "Customer warranty end should be greater than Customer warranty start";
      return;
    }

    if (this.editAssetCommand.factoryWarrantyStart != null
      && this.editAssetCommand.factoryWarrantyEnd != null
      && moment(this.editAssetCommand.factoryWarrantyStart) > moment(this.editAssetCommand.factoryWarrantyEnd)) {
      this.error = "Factory warranty end should be greater than factory warranty start";
      return;
    }

    if (this.editAssetCommand.extendedWarrantyStart != null
      && this.editAssetCommand.extendedWarrantyEnd != null
      && moment(this.editAssetCommand.extendedWarrantyStart) > moment(this.editAssetCommand.extendedWarrantyEnd)) {
      this.error = "Extended warranty end should be greater than extended warranty start";
      return;
    }

    if (this.editAssetCommand.manufacturingDate != null
      && this.editAssetCommand.deliveryDate != null
      && moment(this.editAssetCommand.manufacturingDate) > moment(this.editAssetCommand.deliveryDate)) {
      this.error = "Delivery date should be greater than manufacturing date";
      return;
    }

    if (this.editAssetCommand.deliveryDate != null
      && this.editAssetCommand.commissioningDate != null
      && moment(this.editAssetCommand.deliveryDate) > moment(this.editAssetCommand.commissioningDate)) {
      this.error = "Comissioning date should be greater than delivery date";
      return;
    }

    if (this.editAssetCommand.manufacturingDate != null
      && this.editAssetCommand.nextLifeCyclePhaseDate != null
      && moment(this.editAssetCommand.manufacturingDate) > moment(this.editAssetCommand.nextLifeCyclePhaseDate)) {
      this.error = "Next lifecycle phase date should be greater than manufacturing date";
      return;
    }

    this.saving = true;
    this.assetApiService.updateAsset(id, this.editAssetCommand)
      .subscribe({
        next: response => {
          this.saving = false;
          this.router.navigateByUrl("/asset/" + response.assetId);
        },
        error: error => {
          this.saving = false;
          this.error = error.message
        }
      });
  }

  cancel(): void {
    this.location.back()
  }
}
